import { Redirect, Route } from 'react-router-dom';
import { decodeToken, isUserAuthenticated } from 'utils';

export const ProtectedRoute = ({
  component: Component,
  allowedRoles,
  redirect,
  path,
  ...rest
}) => {
  let allowedUsers;
  const userRole = decodeToken()?.userRole?.RoleName;
  if (allowedRoles?.includes('Applicant')) {
    const isFinishedApplicant = decodeToken()?.applicant !== null;
    if (isFinishedApplicant || path === '/email-change') {
      allowedUsers =
        allowedRoles.includes(userRole) || allowedRoles.includes('All');
    }
  } else {
    allowedUsers =
      allowedRoles.includes(userRole) || allowedRoles.includes('All');
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isUserAuthenticated() ? (
          allowedUsers ? (
            redirect ? (
              <Redirect to={redirect + location.search} />
            ) : (
              <Component {...props} />
            )
          ) : (
            <Redirect to="/not-found" />
          )
        ) : (
          <Redirect to={`/auth`} />
        )
      }
    />
  );
};
